export class OrganizationDriverMappingModel {
  public driverHashId: string;
  public organizationHashId: string;
  public listOfDriverHashId: string[] = [];
  public customerHashId: string;
  public instanceHashId: string;
  public companyHashId: string;
}

export class OrganizationDriverModel {
  public driverMasterHashId: string;
  public driverName: string;
  public firstName: string;
  public lastName: string;
  public personMasterHashId: string;
  public isChecked: boolean;
  public personNotActive: boolean;
  public organizationToDriverMapHashId: string;
  public isDeletable: boolean;
}

export class OrganizationDriverPersonModel {
  public personMasterHashId: string;
  public userName: string;
  public emailAddressModel: OrganizationDriverEmailAddressModel;
  public organizationHashId: string = "";

  constructor() {
    this.emailAddressModel = new OrganizationDriverEmailAddressModel();
  }
}

export class OrganizationDriverEmailAddressModel {
  public email: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationdriver/models/organization-driver.model.ts